<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12 md:col-12">
      <div class="card">
        <div v-if="crudType === 'edit'" class="flex flex-row justify-content-between">
          <span class="text-xl">{{ crudType == "edit" ? "ویرایش هتل/مسافرخانه" : "ثبت هتل/مسافرخانه" }}</span>
          <router-link :to="{ name: 'serviceList', params: { place_id: placeId } }" class="flex flex-row align-items-center p-button-outlined p-button-primary">
            <i class="pi pi-plus"></i>
            <span class="mr-1" v-text="'مدیریت سرویس ها'"></span>
          </router-link>
          <!-- <Button label="مدیریت سرویس" icon="pi pi-plus" class="p-button-success w-2" @click="routeToServicePage" /> -->
        </div>
        <TabView v-model:activeIndex="activeTab">
          <TabPanel center v-for="tab in activeTabs" :key="tab.title" :disabled="tab.disabled">
            <template class="w-max" #header>
              <i :class="tab.icon"></i>
              <span class="mr-2">{{ tab.title }}</span>
            </template>
            <Details v-if="activeTab === 0" :formData="details" :categories="categories" @report-status="investigateStatus" />
            <!--************************* On Development *************************-->
            <keep-alive>
              <Features v-if="activeTab === 1 && !!featureCollections && crudType == 'edit'" :collections="featureCollections" :placeId="placeId" @create-event="getFeatures">
                <template v-slot:specifics>
                  <div class="grid p-fluid">
                    <Divider type="dashed" class="mb-0" />
                    <h6 class="field col-12 mb-0">فاصله تا مکان های خاص:</h6>
                    <div class="field col-12 md:col-5">
                      <div class="p-inputgroup">
                        <InputText
                          v-model="specificPlace.name"
                          placeholder="نام مکان خاص"
                          id="catTitle"
                          type="text"
                          @blur="v$.specificPlace.name.$touch"
                          @input="v$.specificPlace.name.$touch"
                          :class="{
                            'border-red-500 hover:border-red-500 focus:shadow-none': v$.specificPlace.name.$error,
                          }"
                        />
                      </div>
                      <small v-if="v$.specificPlace.name.required.$invalid && v$.specificPlace.name.$dirty" ref="password_error_message" class="text-red-500">
                        {{ v$.specificPlace.name.required.$message }}
                      </small>
                    </div>
                    <div class="field col-12 md:col-5">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <span>متر</span>
                        </span>
                        <InputText
                          v-model="specificPlace.distanceByMeters"
                          placeholder="فاصله از هتل"
                          mode="decimal"
                          type="Number"
                          class="input-Numbers"
                          :min="0"
                          :useGrouping="false"
                          @blur="v$.specificPlace.distanceByMeters.$touch"
                          @input="v$.specificPlace.distanceByMeters.$touch"
                          :class="{
                            'border-red-500 hover:border-red-500 focus:shadow-none': v$.specificPlace.distanceByMeters.$error,
                          }"
                        />
                      </div>
                      <small v-if="v$.specificPlace.distanceByMeters.required.$invalid && v$.specificPlace.distanceByMeters.$dirty" ref="password_error_message" class="text-red-500">
                        {{ v$.specificPlace.distanceByMeters.required.$message }}
                      </small>
                    </div>
                    <div class="field col-12 md:col-2">
                      <Button icon="pi pi-check" :disabled="!specificPlace.name || !specificPlace.distanceByMeters" loadingIcon="pi pi-spinner" :loading="loading['createPlace']" @click="createSpecificPlace(placeId)" class="p-button p-button-primary w-full mb-2">
                        <small>ثبت مکان</small>
                      </Button>
                    </div>
                  </div>
                  <Divider type="dashed" />
                  <div class="grid p-fluid mt-3" v-for="(form, index) in insertedForms" :key="index">
                    <div class="field col-12 md:col-4">
                      <div class="p-inputgroup">
                        <InputText
                          v-model="form.name"
                          placeholder="نام مکان خاص"
                          id="catTitle"
                          type="text"
                          @blur="v$.form.name.$touch"
                          @input="v$.form.name.$touch"
                          :class="{
                            'border-red-500 hover:border-red-500 focus:shadow-none': v$.form.name.$error,
                          }"
                        />
                      </div>
                      <small v-if="v$.form.name.required.$invalid && v$.form.name.$dirty" ref="password_error_message" class="text-red-500">
                        {{ v$.form.name.required.$message }}
                      </small>
                    </div>
                    <div class="field col-12 md:col-4">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <span>متر</span>
                        </span>
                        <InputText
                          v-model="form.distanceByMeters"
                          placeholder="فاصله از هتل"
                          mode="decimal"
                          :min="0"
                          type="Number"
                          class="input-Numbers"
                          :useGrouping="false"
                          @blur="v$.form.distanceByMeters.$touch"
                          @input="v$.form.distanceByMeters.$touch"
                          :class="{
                            'border-red-500 hover:border-red-500 focus:shadow-none': v$.form.distanceByMeters.$error,
                          }"
                        />
                      </div>
                      <small v-if="v$.form.distanceByMeters.required.$invalid && v$.form.distanceByMeters.$dirty" ref="password_error_message" class="text-red-500">
                        {{ v$.form.distanceByMeters.required.$message }}
                      </small>
                    </div>
                    <div class="field col-12 md:col-1 flex flex-row align-items-center justify-content-end">
                      <Button @click="editSelected(form, placeId)" icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-outlined mx-1" />
                      <Button
                        @click="
                          dialog['delete'] = true;
                          selected = form;
                        "
                        icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-outlined mx-1"
                      />
                    </div>
                  </div>
                </template>
              </Features>
            </keep-alive>
            <!--************************* On Development *************************-->
            <Images v-if="activeTab === 2 && crudType == 'edit'" :pictures="pictures" :placeId="placeId" @create-images="getImages" @remove-image="getImages" />
            <keep-alive>
              <Rules v-if="activeTab === 3 && !!rules && crudType == 'edit'" :rules="rules" :placeId="placeId" @create-event="showToast" />
            </keep-alive>
            <CheckStatus v-if="activeTab === 4 && crudType == 'edit'" :placeId="placeId" />
          </TabPanel>
        </TabView>
      </div>
    </div>
    <!-- Delete Dialog Section Begin -->
    <Dialog v-model:visible="dialog['delete']" :style="{ width: '450px' }" header="حذف" :modal="true">
      <div class="flex flex-column align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
        <span v-if="selected" class="mt-3">آیا مطمئن هستید؟</span>
      </div>
      <template #footer>
        <div class="text-center">
          <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="dialog['delete'] = false" />
          <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="removeSelected(selected.id, placeId)" />
        </div>
      </template>
    </Dialog>
    <!-- Delete Dialog Section Ended -->
  </div>
</template>

<script>
import { required, minLength, maxLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import placeDetail from "@/components/place/details.vue";
import placeImages from "@/components/place/images.vue";
import placeRules from "@/components/place/rules.vue";
import placeFeatures from "@/components/place/features.vue";
import checkStatus from "@/components/place/checkStatus.vue";
export default {
  name: "placeCreate",
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Details: placeDetail,
    Images: placeImages,
    Rules: placeRules,
    Features: placeFeatures,
    CheckStatus: checkStatus,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          title: "مشخصات",
          component: "details",
          icon: "pi pi-id-card",
          disabled: false,
        },
        {
          title: "ویژگی ها",
          component: "features",
          icon: "pi pi-palette",
          disabled: true,
        },
        {
          title: "تصاویر",
          component: "images",
          icon: "pi pi-images",
          disabled: true,
        },
        {
          title: "قوانین",
          component: "rules",
          icon: "pi pi-info-circle",
          disabled: true,
        },
        {
          title: "تایید اطلاعات",
          component: "checkStatus",
          icon: "pi pi-check",
          disabled: true,
        },
      ],
      rules: null,
      placeId: null,
      categories: [],
      pictures: [],
      pageSize: 10,
      crudType: "create",
      details: null,
      featureCollections: null,
      specificPlace: {
        name: "",
        distanceByMeters: null,
      },
      insertedForms: [],
      loading: {
        createPlace: false,
      },
      selectedSpecificPlace: null,
      dialog: {
        delete: false,
      },
    };
  },
  validations() {
    return {
      specificPlace: {
        name: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        distanceByMeters: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
      form: {
        name: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        distanceByMeters: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
    };
  },
  computed: {
    getRouterId() {
      this.placeId = this.$route.params.place_id;
      if (this.placeId) {
        this.crudType = "edit";
        this.getPlaceSpecification(this.placeId);
        this.getRules(this.placeId);
        this.getImages(200, this.placeId);
        this.getFeatures(this.placeId);
      }
      this.changeTabActivities(this.crudType);
      return this.crudType;
    },
    activeTabs() {
      return this.tabs.filter((tab) => !tab.disabled);
    },
  },
  watch: {
    getRouterId() {},
    // '$route.params': {
    //     handler: function(val) {
    //         this.placeId = !!val.place_id && val.place_id || '';
    //         if(this.placeId){
    //             this.crudType = 'edit';
    //             this.changeTabActivities(this.crudType);
    //             this.getPlaceSpecification(id)
    //             this.getRules(id)
    //             this.getImages(200 , id)
    //             this.getFeatures(id)
    //         }
    //     },
    //     deep: true,
    //     immediate: true
    // },
  },
  methods: {
    //******* Api methods end *******//
    async getListCategory(page = 1) {
      const { status, data } = await this.axios({ method: "get", url: `Category/GetAll?Title=&PageIndex=${page}&PageSize=${this.pageSize}` });
      this.pageSize = data.pageSize;
      this.categories = [...data.data];
    },
    async getPlaceSpecification(id = this.placeId) {
      const { status, data } = await this.axios({ method: "get", url: `Place/${id}/Specifications` });
      if (status === 200) {
        this.details = { ...data };
      }
    },
    async getRules(id) {
      const { status, data } = await this.axios({ method: "get", url: `Place/${id}/rules` });
      status == 200 ? (this.rules = { ...data }) : false;
    },
    async getImages(status = 200, id = this.placeId) {
      if (status == 200) {
        const { status, data } = await this.axios({ method: "get", url: `Place/${id}/pictures` });
        this.pictures = [...data];
      }
    },
    async getFeatures(id = this.placeId) {
      const { status, data } = await this.axios({ method: "get", url: `Place/${id}/features` });
      this.insertedForms = data["specificPlaces"];
      this.featureCollections = { ...data };
    },
    async createSpecificPlace(id = this.placeId) {
      this.loading["createPlace"] = true;
      const { status, data } = await this.axios({ method: "post", url: `Place/${id}/specificplace`, data: this.specificPlace });
      if (status == 200) {
        this.getFeatures(id);
        this.showToast(status);
      } else {
        this.showToast(status, data.errors);
      }
      this.loading["createPlace"] = false;
      this.specificPlace = { name: "", distanceByMeters: 0 };
    },
    async editSelected(selected, placeId) {
      const { status, data } = await this.axios({ method: "put", url: `Place/${placeId}/specificplace/${selected.id}`, data: selected });
      this.showToast(status, data.errors);
    },
    async removeSelected(id, placeId) {
      const { status, data } = await this.axios({ method: "delete", url: `Place/${placeId}/specificplace/${id}` });
      this.showToast(status, data.errors);
      this.dialog["delete"] = false;
      status == 200 && (this.insertedForms = this.insertedForms.filter((item) => item.id !== id));
      this.selectedSpecificPlace = null;
    },
    //******* Api methods end *******//
    changeTabActivities(type) {
      if (type == "edit") {
        this.tabs.map((t) => (t.disabled = false));
      }
    },
    //******* Creation methods begin *******//
    investigateStatus(data) {
      data.status == 200 ? this.$router.push(`/place/edit/${data.id}`) : false;
    },
    //******* Creation methods end *******//
    addForm: function () {
      this.insertedForms.push({ title: "", distance: 0 });
    },
  },
  mounted() {
    this.getListCategory();
  },
};
</script>

<style lang="scss">
.p-tabview-nav-link {
  width: max-content;
}
.input-Numbers::-webkit-outer-spin-button,
.input-Numbers::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.input-Numbers[type="number"] {
  -moz-appearance: textfield;
}
</style>
